<div class="container" [class]="appearance || 'white'" prlwResponsive>
  <ng-content></ng-content>
</div>
